import * as React from "react";
import {
  ReferenceInput,
  AutocompleteInput,
  ReferenceField,
  TextField as RaTextField,
  useRecordContext,
} from "react-admin";

const userOptionText = (record) => {
  if (!record) return "";
  const name = [record.firstName, record.lastName].filter(Boolean).join(" ");
  return name || record.email || record.id;
};

export const UserReferenceInput = ({ source = "userId", label, ...rest }) => (
  <ReferenceInput source={source} reference="users" {...rest}>
    <AutocompleteInput
      optionText={userOptionText}
      label={label}
      filterToQuery={(q) => ({ q })}
      sx={{ minWidth: 260 }}
    />
  </ReferenceInput>
);

export const ProReferenceInput = ({ source = "proId", label, ...rest }) => (
  <ReferenceInput source={source} reference="professionals" {...rest}>
    <AutocompleteInput
      optionText={userOptionText}
      label={label}
      filterToQuery={(q) => ({ q })}
      sx={{ minWidth: 260 }}
    />
  </ReferenceInput>
);

export const PatientReferenceInput = ({
  source = "patientId",
  label,
  ...rest
}) => (
  <ReferenceInput source={source} reference="patients" {...rest}>
    <AutocompleteInput
      optionText={userOptionText}
      label={label}
      filterToQuery={(q) => ({ q })}
      sx={{ minWidth: 260 }}
    />
  </ReferenceInput>
);

export const SpecialityReferenceInput = ({
  source = "specialityId",
  label,
  ...rest
}) => (
  <ReferenceInput source={source} reference="specialities" {...rest}>
    <AutocompleteInput
      optionText={(r) => r?.name || r?.label || r?.id}
      label={label}
      filterToQuery={(q) => ({ q })}
    />
  </ReferenceInput>
);

export const UserReferenceField = ({ source = "userId", label }) => (
  <ReferenceField source={source} reference="users" label={label} link="show">
    <UserName />
  </ReferenceField>
);

export const UserName = () => {
  const r = useRecordContext();
  return <RaTextField source={null} record={{ value: userOptionText(r) }} />;
};
